import { render, staticRenderFns } from "./PodcastInfo.vue?vue&type=template&id=5935e5a6&"
import script from "./PodcastInfo.vue?vue&type=script&lang=js&"
export * from "./PodcastInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports